import * as ActionTypes from 'store/actionTypes';
import {config} from "config/config";

const defaultState = {
  locale: config?.defaultEnvironmentLocale ? config.defaultEnvironmentLocale : 'EN'
}

const Locale = (state = defaultState, action: any) => {
  switch(action.type) {
    case ActionTypes.CHANGE_LOCALE:
      var locale = action.payload;
      return {...state, locale: locale};

    default:
      return state;
  }
}

export default Locale;
